import qs from 'qs'
import React from 'react'
import { connect } from 'react-redux'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import SelectOrgAccountView from './SelectOrgAccountView'

import {
  withContext,
  WithContextProps,
} from 'admin/components/common/withContext'
import { State } from 'admin/redux/ducks'
import {
  getLoginUrlAction,
  setLoginDataAction,
  loginUserAction,
  LoginState,
} from 'admin/redux/ducks/login'
import { AdminTypes } from 'types'

const SelectOrgAccount: React.FunctionComponent<
  SelectOrgAccountProps & WithContextProps
> = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const selectOrgAccount = (
    orgAccountId: string,
    orgNumber: string,
    administratorType: AdminTypes
  ) => {
    const { setLoginData, loginUser, config } = props
    const { redirect } = qs.parse(location.search.substr(1))
    setLoginData({ orgNumber, orgAccountId, administratorType })
      .then(loginUser)
      .then(() => {
        if (redirect) {
          navigate(redirect)
        } else {
          navigate(config.locations.loginDestination.to)
        }
      })
  }

  const resetLogin = () => {
    navigate('/logga_ut')
  }

  const { login, config } = props
  if (login.data && login.data.isAuthenticated) {
    // Already logged in
    if (login.data.isLoggedIn && login.data.orgAccountId) {
      return <Navigate {...config.locations.loginDestination} />
    }
    return (
      <SelectOrgAccountView
        login={login}
        onSelect={selectOrgAccount}
        onReset={resetLogin}
      />
    )
  }
  return <Navigate {...config.locations.login} />
}

type SelectOrgAccountProps = {
  clientId: string
  login: LoginState
  getLoginUrl: (clientId: string) => string
  setLoginData: (loginData) => Promise<any>
  loginUser: (loginData) => Promise<any>
}

const mapStateToProps = (state: State, ownProps) => {
  return {
    login: state.login as LoginState,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLoginUrl: (clientId) => dispatch(getLoginUrlAction(clientId)),
    setLoginData: (loginData) => dispatch(setLoginDataAction(loginData)),
    loginUser: () => dispatch(loginUserAction()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContext(SelectOrgAccount))
